var Buffer = require('buffer/').Buffer

export const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIxIiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvZW1haWxhZGRyZXNzIjoiYW50YWx5YW51ZXZvdGVzdEBnbWFpbC5jb20iLCJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6IjI2OTgzNTIxMTk2IiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvbW9iaWxlcGhvbmUiOiI1MzI2MTA5OTYyIiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9yb2xlIjoiQWRtaW5pc3RyYXRvciIsIm5iZiI6MTY1ODgyNTkxMiwiZXhwIjoxNjkwMzgzNTEyLCJpc3MiOiJIYXZhc1BvcnRhbEFwaSIsImF1ZCI6Imh0dHBzOi8vbG9jYWxob3N0OjQ0MzU3LyJ9.dMHNUcX6-_CZYiKWA_ZcMFwYZFHBxvlusuWmv_5Px9s'

export function parseToken(token) {
    if (!token) { return; }
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    const buffer = Buffer(base64,'base64')
    return buffer.toString();
    
}

export const setUserToStorage = (token) => {
    localStorage.setItem('userInfo',parseToken(token))
}

export const getUserInfo = () => {
    return JSON.parse(localStorage.getItem('userInfo'))
}